import {ActionType} from 'redux/actions/additionalHealthActionTypes';
import {AdditionalHealthPaperwork, AddHealth, Paperwork} from 'lib/entities';

export function saveAddHealth(addHealth: AddHealth, {shouldEndEditing = false} = {}) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_SAVE,
        payload: addHealth,
        meta: {shouldEndEditing},
    };
}

export function saveAddHealthSuccess(addHealth: AddHealth, {shouldEndEditing = false} = {}) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_SAVE_SUCCESS,
        payload: addHealth,
        meta: {shouldEndEditing},
    };
}

export function saveAddHealthFailed(addHealth: AddHealth, error?: Error | string) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_SAVE_FAILED,
        payload: addHealth,
        error,
    };
}

export function saveAdditionalHealthPaperwork(paperwork: Partial<AdditionalHealthPaperwork>) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_SAVE_PAPERWORK,
        payload: paperwork,
    };
}

export function saveAdditionalHealthPaperworkSuccess(paperwork: AdditionalHealthPaperwork) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_SAVE_PAPERWORK_SUCCESS,
        payload: paperwork,
    };
}

export function saveAdditionalHealthPaperworkFailed(
    paperwork: Partial<AdditionalHealthPaperwork>,
    error?: Error | string,
) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_SAVE_PAPERWORK_FAILED,
        payload: paperwork,
        error,
    };
}

export function startAdditionalHealth() {
    return {
        type: ActionType.ADDITIONAL_HEALTH_START,
    };
}

export function startAdditionalHealthFailed(error: Error | string) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_START_FAILED,
        error,
    };
}

export function startAdditionalHealthSuccess(paperwork: Paperwork) {
    return {
        type: ActionType.ADDITIONAL_HEALTH_START_SUCCESS,
        payload: paperwork,
    };
}
